module.exports = __webpack_public_path__ + "static/wakayama-advancement-73cc0a84739ccd8d6c126866394eed21.png";